export const PACKAGE_NAME = 'jiraProjectDirectoriesComponents';
